import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetProviderTypeModel } from "@factory/model/query-model-provider-type";
import { providerTypeFormDefault } from "./form.default";
import { ProviderTypeFormSchema } from "./form.rule";

export const useFormDefaultProviderType = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetProviderTypeModel | undefined) => {
    return !cachedValue
      ? providerTypeFormDefault
     : ({
        name: cachedValue.name,
        description: cachedValue.description,
        tenant: cachedValue.tenant,
      } as ProviderTypeFormSchema);
  };

  return {
    getDefault,
  };
};
